<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display folder-workflow"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text" primary-title>
        Folders
      </v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card height="100%" class="folder-card-section">
      <v-card-text>
        <v-row class="custom-form-control">
          <v-col cols="12" lg="3" md="4" class="text-left pt-0 pb-0">
            <div class="title-grid-folder">
            </div>
          </v-col>
          <v-col class="comm-header-col date-query-section pt-0 pb-0 pr-0 text-right" lg="9" md="8">
            <div class="d-inline-flex">
              <v-text-field
                :placeholder="$t('lbl.mapBuilder.loadFile.searchFolderPlaceHolder')"
                append-icon="fas fa-search"
                height="30"
                dense
                solo
                hide-details
                v-model="searchLeft"
                class="search-button mt-0 mb-2"
              ></v-text-field>
              <v-btn
                small
                text
                icon
                @click="deleteItem"
                :disabled="selectTreeItems.length === 0"
                class="ml-2"
              >
                <icon-svg iconName="delete" size="24" :disabled="selectTreeItems.length === 0" />
              </v-btn>
              <v-btn
                small
                text
                icon
                @click="addFolder"
                :disabled="!activeFolder || activeFolder.level > 2"
              >
                <icon-svg
                  iconName="add"
                  size="24"
                  :disabled="!activeFolder || activeFolder.level > 2"
                />
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row class="tree-panel" no-gutters>
          <v-col cols="12">
            <v-row class="no-gutters">
              <v-treeview
                :search="searchLeft"
                :items="treeItems"
                :item-key="'id'"
                :selection-type="'independent'"
                return-object
                ref="folderTreeView"
                v-model="tree"
                activatable
                selectable
                class="analyzedTree custom-tree file-view-wrap"
                @input="onSelectTreeItem"
                @update:active="updateActive"
              >
                <template v-slot:label="{ item, open }">
                  <div
                    v-if="item.status != 'added'"
                    :class="['group-has-children-item', 'display-flex', item.id]"
                    @contextmenu.stop="showContextMenu($event, item)"
                    @dblclick="selectFolder(item)"
                  >
                    <v-icon
                      small
                      v-if="open && item.children.length > 0"
                      @click.stop="openItemClick(item, false)"
                      class="mr-1"
                      >fas fa-caret-down</v-icon
                    >
                    <v-icon
                      small
                      v-if="!open && item.children.length > 0"
                      @click.stop="openItemClick(item, true)"
                      class="mr-1"
                      >fas fa-caret-right</v-icon
                    >
                    <v-icon small class="folder-icon mr-1" color="#FFE792">fas fa-folder</v-icon>
                    <div
                      v-if="typeContext == 'Rename' && item.id === selectedId"
                      class="group-has-children-item display-flex"
                    >
                      <v-text-field
                        :ref="'folder' + item.id"
                        v-model="item.name"
                        class="new-folder-text-field"
                        dense
                        solo
                        hide-details
                        outlined
                      >
                      </v-text-field>
                      <v-btn
                        small
                        text
                        icon
                        @click.stop="saveTreeFolderItem(item)"
                        class="ml-1 d-inline-flex"
                      >
                        <icon-svg iconName="save" size="24" />
                      </v-btn>
                      <v-btn
                        small
                        text
                        icon
                        @click.stop="cancelSaveTreeFolderItem(item)"
                        class="ml-0 d-inline-flex"
                      >
                        <icon-svg iconName="cancel" size="24" />
                      </v-btn>
                    </div>
                    <div v-else>{{ item.name }}</div>
                  </div>
                  <div v-if="item.status == 'added'" class="group-has-children-item display-flex">
                    <v-icon small class="mr-1">fas fa-folder</v-icon>
                    <v-text-field
                      class="new-folder-text-field"
                      v-model="item.name"
                      dense
                      solo
                      hide-details
                    ></v-text-field>
                    <v-btn
                      small
                      text
                      icon
                      @click.stop="saveTreeFolderItem(item)"
                      class="ml-1 d-inline-flex"
                    >
                      <icon-svg iconName="save" size="24" />
                    </v-btn>
                    <v-btn
                      small
                      text
                      icon
                      @click.stop="cancelSaveTreeFolderItem(item)"
                      class="ml-0 d-inline-flex"
                    >
                      <icon-svg iconName="cancel" size="24" />
                    </v-btn>
                  </div>
                </template>
                <template v-slot:append="{ item }">
                  <div
                    v-if="item.status != 'added' && item.id == '0000000000'"
                    :class="['group-has-children-item', 'display-flex', item.id]"
                  >
                    <v-btn
                      class="btn btn-search"
                      @click="expandAllTreeView($event)"
                      color="primary"
                      dark
                      ref="expandAll"
                    >
                      {{ expand }}
                    </v-btn>
                  </div>
                </template>
              </v-treeview>
              <v-menu
                v-model="showMenu"
                :position-x="x"
                :position-y="y"
                absolute
                offset-y
                content-class="file-menu-context"
              >
                <v-list flat>
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in contexts"
                      :key="i"
                      @click="selectContextMenu(item)"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="item.text"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <dialogWindow
        ref="deleteDialog"
        size="max"
        title="Delete Communication"
        :detail="$t('msg.common.infoConfirm.detail', ['delete the folder'])"
        color="confirmation"
        :showCancel="true"
        @select-ok="onDeleteItem()"
      ></dialogWindow>
      <dialogWindow
        ref="warningAddNewFolderDialog"
        size="max"
        title="Warning"
        :detail="warningDetail"
        color="validation"
      ></dialogWindow>
    </v-card>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn class="btn btn-close mdl-10" dark @click="removeDialog">
          {{ $t('btn.common.close') }}
        </v-btn>
      </v-col>
    </v-row>
  </dialog-drag>
</template>

<script>
import { FolderTreeParser } from '@/vue-caas/utils/foldtree_parser';
const msgtreeParser = new FolderTreeParser();
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import cfg from '@/vue-caas/config/config.js';

export default {
  props: {
    items: {
      default: Array,
    },
    foldList: {
      default: Array,
    },
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    prs: Object,
    nodeId: String,
    comId: String,
  },
  components: {
    dialogWindow,
    DialogDrag,
    IconSvg, // 2021.12.1 SPKA-297 svg icon
  },

  data() {
    return {
      folderData: Array,
      searchLeft: '',
      expand: 'Expand',
      selectTreeItems: [],
      tree: [],
      activeFolder: null,
      treeItems: [],
      leftItems: {
        header: ['USER_ID'],
        data: [
          {
            USER_ID: '',
          },
        ],
      },
      deleteFolderHeader: {
        header: ['USER_ID', 'FOLD_ID'],
        data: [
          {
            USER_ID: '',
            FOLD_ID: '',
          },
        ],
      },
      addFolderHeader: {
        header: ['PA_FOLD_ID', 'PA_FOLD_LVL', 'FOLD_NAME'],
        data: [
          {
            PA_FOLD_ID: '',
            PA_FOLD_LVL: '',
            FOLD_NAME: '',
          },
        ],
      },
      pathFolder: '',
      foldId: '',
      showMenu: false,
      contexts: [
        { text: this.$t('lbl.mapBuilder.loadFile.contextMenu.rename') },
        { text: this.$t('lbl.mapBuilder.loadFile.contextMenu.refresh') },
      ],
      x: 0,
      y: 0,
      typeContext: '',
      selectedId: '',
      updateFolderHeader: {
        data: [
          {
            FOLD_NAME: '',
            FOLD_ID: '',
          },
        ],
      },
      warningDetail: '',
    };
  },
  watch: {
    foldList() {
      console.log('change', this.foldList);
      this.treeItems = msgtreeParser.parse(this.foldList);
    },
    comId() {
      setTimeout(() => {
        this.foldId = this.comId;
        this.$refs.folderTreeView.updateActive(this.comId, true);
      }, 1000);
    },
  },
  created() {
    this.folderData = this.items;
    console.log('created', this.foldList);
    this.treeItems = msgtreeParser.parse(this.foldList);
    console.log('tree', this.treeItems);
    this.foldId = this.comId;
  },
  mounted() {
    setTimeout(() => {
      this.$refs.expandAll.$el.click();
    }, 1000);
    setTimeout(() => {
      console.log('Check folder tree', this.$refs.folderTreeView, this.comId);
      this.foldId = this.comId;
      if (this.$refs.folderTreeView) this.$refs.folderTreeView.updateActive(this.comId, true);
    }, 1000);
  },
  methods: {
    deleteItem(item) {
      this.deleteFolderHeader = [];
      let self = this;
      let check = function(value) {
        let chk = self.deleteFolderHeader.findIndex((e) => e.FOLD_ID === value);
        if (chk < 0) self.deleteFolderHeader.push({ FOLD_ID: value });
      };
      for (let i = 0; i < this.selectTreeItems.length; i++) {
        check(this.selectTreeItems[i].id);
        if (this.selectTreeItems[i].children.length > 0) {
          this.selectTreeItems[i].children.map((lv2) => {
            check(lv2.id);
            if (lv2.children.length > 0) {
              lv2.children.map((lv3) => check(lv3.id));
            }
          });
        }
      }
      if (cfg.isDlb) {
        self.$refs.deleteDialog.dialog = true;
      } else {
        this.$store
          .dispatch('getListUseInWorkflow', {
            type: 'FOLDER',
            value: '',
            listChk: this.deleteFolderHeader,
          })
          .then((res) => {
            if (res.length > 0) {
              EventBus.$emit('openDelHistoryWorkflowDialog', res);
            } else {
              self.$refs.deleteDialog.dialog = true;
            }
          });
      }
    },
    onDeleteItem(item) {
      this.$store.dispatch('deleteWorkSpaceFolders', this.deleteFolderHeader).then(() => {
        console.log('--------- finished ----------');
        this.$emit('queryLeftList');
      });
    },
    onSelectTreeItem(item) {
      this.selectTreeItems = item.filter((e) => e.status != 'added');
      console.log('onSelectTreeItem: ', this.selectTreeItems);
    },
    updateActive(arr) {
      if (arr[0]) {
        this.pathFolder = arr[0].foldpath;
        this.foldId = arr[0].id;
      }
      if (arr.length == 0) {
        this.activeFolder = null;
        return;
      }
      if (arr[0].status != 'added') {
        this.$emit('queryRighttList', arr[0]);
        this.activeFolder = arr[0];
      }
    },
    openItemClick(item, open) {
      this.$refs.folderTreeView.updateOpen(item.id, open);
    },
    deleteFolder() {
      if (this.selectTreeItems.length == 0) {
        this.$refs.warningDeleteFolder.dialog = true;
      } else {
        this.$refs.confirmDialog.dialog = true;
      }
    },
    addFolder() {
      if (this.activeFolder == null) {
        this.$refs.warningAddNewFolderDialog.dialog = true;
        this.warningDetail = 'Please select folder';
        return;
      }
      let selectTree = this.activeFolder;
      selectTree.children.push({
        children: [],
        id: 'test',
        parentlevel: selectTree.level,
        name: 'New Folder',
        parentid: selectTree.id,
        status: 'added',
      });
      let treeData = this.treeItems;

      setTimeout(() => {
        this.treeItems = treeData;
        this.$nextTick(() => {
          this.$refs.folderTreeView.updateOpen(this.activeFolder.id, true);
        });
      }, 300);
    },
    saveTreeFolderItem(item) {
      let name = item.name.trimStart().trimEnd();
      if (!name) {
        this.$refs.warningAddNewFolderDialog.dialog = true;
        this.warningDetail = 'Please input folder name';
        return;
      }

      let foldListCheck = this.foldList.filter((e) => e.FOLD_PA_ID === item.parentid);
      let checkName = foldListCheck.filter((e) => e.FOLD_NAME === name);
      if (checkName.length > 0) {
        this.$refs.warningAddNewFolderDialog.dialog = true;
        this.warningDetail = 'Duplicate folder name';
        return;
      }
      if (this.typeContext == 'Rename') {
        this.updateFolderHeader.data[0].FOLD_NAME = name;
        this.updateFolderHeader.data[0].FOLD_ID = item.id;
        console.log('updateFolder: ', this.updateFolderHeader.data[0]);
        this.$store.dispatch('updateFolder', this.updateFolderHeader.data[0]).then(() => {
          this.$emit('queryLeftList');
          this.typeContext = '';
        });
      } else {
        this.addFolderHeader.data[0].FOLD_NAME = name;
        this.addFolderHeader.data[0].PA_FOLD_ID = item.parentid;
        this.addFolderHeader.data[0].PA_FOLD_LVL = item.parentlevel;
        console.log('updateFolder: ', this.addFolderHeader.data[0]);
        
        this.$store.dispatch('addFolder', this.addFolderHeader.data[0]).then(() => {
          console.log('--------- finished ----------');
          this.$emit('queryLeftList');
        });
      }
    },
    expandAllTreeView(e) {
      if (e == undefined) {
        this.$refs.folderTreeView.updateOpen('0000000000', true);
      } else {
        e.stopImmediatePropagation();
        this.openAll = !this.openAll;
        if (this.openAll) {
          this.expand = 'Collapse';
          this.$refs.folderTreeView.updateAll(this.openAll);
        } else {
          this.expand = 'Expand';
          this.$refs.folderTreeView.updateAll(this.openAll);
          this.$refs.folderTreeView.updateOpen('0000000000', true);
        }
      }
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    cancelSaveTreeFolderItem(item) {
      let status = item.status;
      this.selectedId = '';
      this.typeContext = '';
      if (status === 'added' && this.activeFolder) {
        this.activeFolder.children = this.activeFolder.children.slice(0, -1);
        let treeData = this.treeItems;
        setTimeout(() => {
          this.treeItems = treeData;
          this.$nextTick(() => {
            this.$refs.folderTreeView.updateOpen(this.activeFolder.id, true);
          });
        }, 300);
      }
      this.$emit('queryLeftList');
    },
    async selectContextMenu(item) {
      this.typeContext = item.text;
      if (this.typeContext === 'Rename') {
        console.log('Rename Folder: ', this.typeContext);
      } else if (this.typeContext === 'Delete') {
        console.log('Delete Folder: ', this.typeContext);
        this.deleteFolder();
      } else if (this.typeContext === 'Refresh') {
        console.log('Refresh Folder: ', this.typeContext);
        this.$emit('queryLeftList');
      }
    },
    showContextMenu(e, item) {
      e.preventDefault();
      this.selectedId = item.id;
      console.log('selected id:', this.selectedId);
      if (this.selectedId) {
        this.$refs.folderTreeView.updateActive(this.selectedId, true);
        this.showMenu = true;
        this.x = e.clientX;
        this.y = e.clientY;
      } else {
        this.showMenu = false;
        return;
      }
    },
    selectFolder(item) {
      this.foldId = item.id;
      this.pathFolder = item.foldpath;
      if (this.foldId && this.pathFolder) {
        this.$emit('selectPathFolder', {
          foldId: this.foldId,
          pathFolder: this.pathFolder,
          nodeId: this.nodeId,
        });
      }
      this.removeDialog({});
    },
  },
};
</script>
<style>
.folder-workflow {
  width: 525px !important;
}
</style>
